import { get, post, put, remove as httpRemove } from "../Services/http";
const rootRoute = "/api/gtm";

export const pushCheckoutEvent = () => (dispatch) =>
  get(`${rootRoute}/checkout`)
    .then((response) => response.json())
    .then((json) => pushToDataLayer(json));

export const pushProductPageEvent = (articleNumber) => (dispatch) =>
  get(`${rootRoute}/productPage?articleNumber=${articleNumber}`)
    .then((response) => response.json())
    .then((json) => pushToDataLayer(json));

export const pushOrderConfirmationPageEvent = (orderId) =>
  get(`${rootRoute}/orderConfirmationPage?orderId=${orderId}`)
    .then((response) => response.json())
    .then((json) => {      
      pushToDataLayer(json);
      var leadData = {'event': 'formSubmitted',
        'leadsUserData': {
          'email': json.ecommerce.purchase.actionField.email,
          'phone_number': json.ecommerce.purchase.actionField.telephone,
        }
      }
      pushToDataLayer(leadData);
    });

export const pushAddToCartEvent = (itemsWithQuantity, sendToGTM) =>
  post(`${rootRoute}/addToCart/${sendToGTM}`, itemsWithQuantity)
    .then((response) => response.json())
    .then((json) => pushToDataLayer(json));

const pushToDataLayer = (data) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);
};
